
import React from 'react';
import {
  Card,
  CardMedia,
  CardContent,
  CardActions,
  Typography,
  Box,
  Divider,
  Button
} from '@mui/material';

import BranchStockDialog from './BranchStockDialog';    
import ExtraDescriptDialog from './extraDescriptDialog';
import ContactDialog from './ContactDialog';


const ProductCard = ({ product, onSelect, onAddToCart }) => {
  const { id_prod, desc_prod_full, sell_unit_std, id_uom___1, id_gst_rate, qty_on_hand, desc_grp_prod } = product;

  const FALLBACK_IMAGE = '/images/noimage.jpg';
  const PRODUCT_IMAGE = `/images/${id_prod}.jpg`;
  
  // GST Added - ensure it is added correctly
  const unit = sell_unit_std;
  const gstRate = Number(id_gst_rate);
  let calc_sell_price;

  if (gstRate === 1) {
    calc_sell_price = unit * 1.1;
  } else {
    calc_sell_price = unit;
  }
  const sell_price = `$${Number(calc_sell_price).toFixed(2)} / ${id_uom___1}`

   // Dialog State
  const [dialogOpen, setDialogOpen] = React.useState(false);
    const handleOpenDialog = () => setDialogOpen(true);
    const handleCloseDialog = () => setDialogOpen(false);

     const handleConfirmAddToCart = (selections) => {
        //selections [{id_branch, requestedQty}]
        // You can filter out zero quantities if needed
        const nonZero = selections.filter(s => s.requestedQty > 0);
        onAddToCart?.( {product, branchSelections: nonZero} );
        

     };

  const [extraDialogOpen, setExtraDialogOpen] = React.useState(false);
    const handleOpenExtraDialog = () => setExtraDialogOpen(true);
    const handleCloseExtraDialog = () => setExtraDialogOpen(false);   

  const [contactDialogOpen, setContactDialogOpen] = React.useState(false);
    const handleOpenContactDialog = () => setContactDialogOpen(true);
    const handleCloseContactDialog = () => setContactDialogOpen(false);

    return (
    <>
      <Card
        elevation={2}
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'stretch',
          height: 200,
          border: '1px solid #ddd',
          borderRadius: 2,
          overflow: 'hidden',
          '&:hover': { boxShadow: 4, borderColor: '#bbb' }
        }}
      >
        {/* Left: Image fills card height */}
        <CardMedia
          component="img"
          image={PRODUCT_IMAGE}
          alt={desc_prod_full}
          onError={(e) => { e.currentTarget.src = FALLBACK_IMAGE; }}
          loading="lazy"
          sx={{
            height: '100%',
            width: 200,
            objectFit: 'cover',
            flexShrink: 0
          }}
        />

        {/* Vertical divider between image and content */}
        <Divider orientation="vertical" flexItem />

        {/* Right: Content column (title at top, actions at bottom) */}
        <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
          <CardContent sx={{ p: 2, pb: 1, flex: 1 }}>
            {/* Header: code chip + title */}
            <Box display="flex" alignItems="center" gap={1} mb={1}>

              {/* fixed the 'disaplay' typo to 'display' below */}

              <Box sx={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
                <Typography variant="h6" sx={{ fontWeight: 700, ml: 1 }}>
                  Code: {id_prod}
                </Typography>

                <Typography variant="h4" sx={{ fontWeight: 700, ml: 1 }}>
                  {desc_prod_full}
                </Typography>

                <Typography variant="h6" sx={{ fontWeight: 700, ml: 1 }}>
                  Group: {desc_grp_prod}
                </Typography>

                {/* Row for price (left) and qty (right) */}
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'baseline',
                    justifyContent: 'space-between',
                    gap: 2,
                    ml: 1,
                    pr: 1,            // optional right padding so the right label isn’t flush
                    width: '100%',    // ensure it spans the row
                    whiteSpace: 'nowrap',
                    overflow: 'hidden' // avoid layout shift if text is long
                  }}
                >
                  <Typography variant="h4" sx={{ fontWeight: 700, mr: 2 }}>
                    {sell_price}
                  </Typography>

                  <Typography variant="h4" sx={{ fontWeight: 700, ml: 2 }}>
                    {`Stock On Hand: ${qty_on_hand}`}
                  </Typography>
                </Box>
              </Box>

            </Box>


          </CardContent>

          <Divider />

          <CardActions sx={{ p: 1.5 }}>
            <Button
              variant="outlined"
              size="medium"
              sx={{ ml: 1, fontWeight: 700 }}
              onClick={handleOpenDialog}
            >
              View Stocks
            </Button>
            <Button
              variant="outlined"
              size="medium"
              sx={{ ml: 1, fontWeight: 700 }}
              onClick={handleOpenExtraDialog}
            >
              View Extra Details
            </Button>
            <Button
              variant="outlined"
              size="medium"
              sx={{ ml: 1, 
              fontWeight: 700,
              color: '#d32f2f',
              borderColor: '#d32f2f',
              '&:hover': {
                color: '#b71c1c',
                backgroundColor: "rgba(211, 47, 47, 0.08",
                borderColor: '#b71c1c',
              },
            }}
              onClick={handleOpenContactDialog}
            >
              I'm Interested 
            </Button>

            
          </CardActions>
        </Box>
      </Card>

      {/* Branch stock modal */}
      <BranchStockDialog
        open={dialogOpen}
        onClose={handleCloseDialog}
        product={product}
        onConfirm={handleConfirmAddToCart}
      />
      <ExtraDescriptDialog
        open={extraDialogOpen}
        onClose={handleCloseExtraDialog}
        product={product}
      />
      <ContactDialog
        open={contactDialogOpen}
        onClose={handleCloseContactDialog}
        product={product}
      />

    </>
  );
};

export default ProductCard;
